(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("FlyersImportHubSelectFlyerController", FlyersImportHubSelectFlyerController);

    function FlyersImportHubSelectFlyerController($window, $sessionStorage, $localStorage, $state, $stateParams, $translate, $uibModal,
                                                  systemConstants, paginationConstants, toastr, HubFlyersService,
                                                  FlyersService, FlyerCategoryService, StoreService, $scope, MODAL_CONTENT_TYPES) {
        var vm = this;

        vm.$onInit = init;
        vm.onFilterChanged = onFilterChanged;
        vm.isFlyerSelected = isFlyerSelected;
        vm.refreshSelectedFlyers = refreshSelectedFlyers;
        vm.onChangeItemsPerPage = onChangeItemsPerPage;
        vm.changePage = changePage;
        vm.onSelectedSortOption = onSelectedSortOption;
        vm.getTranslateKey = getContextTranslateKey;
        vm.isAllFromPageSelected = isAllFromPageSelected;
        vm.isIndeterminate = isIndeterminate;
        vm.loadFilter = loadFilter;
        vm.openFiltersModal = openFiltersModal;
        vm.selectAllFiltered = selectAllFiltered;
        vm.selectAllFromPage = selectAllFromPage;
        vm.unselectAll = unselectAll;
        vm.noneSelected = noneSelected;
        vm.finishImport = finishImport;
        vm.goBack = goBack;
        vm.listCategoryFilterOptions = HubFlyersService.listCategoryFilterOptions;
        vm.listBrandFilterOptions = HubFlyersService.listBrandFilterOptions;
        vm.brandValueMap = { id: 'value', label: 'label', value: 'value' };
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.viewInitialized = false;
        vm.emptyFiltersShowcases = false;
        vm.scrollableNavBarItemTemplate =
            'app/admin/flyers/import-hub/select-flyers/scrolable-nav-bar/nav-item-template.html';

        vm.isLoadingBrands = false;
        vm.isLoadingFlyers = false;

        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        vm.selectedBrandTabIndex = 0;
        vm.selectedBrandTabName = undefined;
        vm.brands = [];
        vm.flyers = [];
        vm.totalFlyers = undefined;

        vm.loadingSelection = false;
        vm.selectionTypes = [];
        vm.selectedFlyers = [];
        vm.selectedBrands = [];
        vm.selectionExcludedFlyers = [];

        vm.currentPage = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPageSmall;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.maxPaginationControlSize = 5;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.itemsPerPage
        };

        vm.brandListFilter = {};
        vm.flyerFilter = {};
        vm.selectedSortByOption = undefined;

        vm.configurations = undefined;

        vm.bedrooms = [
            {id: 1, label: "1", value: 1 },
            {id: 2, label: "2", value: 2 },
            {id: 3, label: "3", value: 3 },
            {id: 4, label: "4", value: 4 },
            {id: 5, label: "5+", value: 5 },
        ];

        vm.selectionTypesData = {
            currentSelection: 'NONE',
            'ALL': {
                selectFunc: selectAllFiltered
            },
            'ALL_FROM_PAGE': {
                selectFunc: selectAllFromPage
            },
            'NONE': {
                selectFunc: unselectAll
            }
        };

        vm.isSaving = false;

        vm.selectedFilters = [];

        function init() {
            if ((!$sessionStorage.hubImportBrandFilter || !$sessionStorage.hubImportMultiSelectFilters) && !vm.isImmoContext) {
                $state.go('flyers.import-hub');
            } else {
                vm.brandFilter = {
                    sortBy: 'brand',
                    sortDirection: 'asc'
                };

                if(vm.isImmoContext) {
                    vm.sortOptions = paginationConstants.hubSortOptions[$translate.use().toLowerCase()].filter(function (type) {
                        return type.value !== "isBasic" && type.value !== "discountValue";
                    });

                    // TODO refatorar seleção multipla de brands para ficar padronizado de acordo com o restante dos filtros
                    //  multi-select com opção de "selecionar todos"
                    vm.brandFilter.brandSelection = { allBrands: true, brands: [], excludedBrands: [] };

                    vm.dynamicFilterOptions = {
                        brands: getDynamicFilterOptionsModel(true)
                    }
                } else {
                    vm.sortOptions = paginationConstants.hubSortOptions[$translate.use().toLowerCase()];

                    vm.brandFilter.brandSelection = $sessionStorage.hubImportBrandFilter.brandSelection ||
                        { allBrands: false, brands: [], excludedBrands: [] };

                    vm.dynamicFilterOptions = {
                        categories: $sessionStorage.hubImportDynamicFilterOptions.categories,
                        brands: getDynamicFilterOptionsModel(true),
                        colors: $sessionStorage.hubImportDynamicFilterOptions.colors,
                        sizes: $sessionStorage.hubImportDynamicFilterOptions.sizes
                    }

                    vm.dynamicFilterOptions.brands.selectAllOption = true;
                }

                loadAllBrands();
                loadFiltersOptions();

                vm.currencyInstance = $localStorage.defaultStore.storeInfo.currencyConfiguration;

                vm.brandListFilter = vm.brandFilter;
                vm.selectedFilters = angular.copy(vm.brandListFilter);

                if (vm.dynamicFilterOptions.brands.selectAllOption && angular.isFunction(vm.listBrandFilterOptions)) {
                    if (vm.brandFilter.brandSelection) {
                        var brandsList = vm.brandFilter.brandSelection.brands;

                        vm.selectedFilters.brands = {
                            all: vm.brandFilter.brandSelection.allBrands || false,
                            only: brandsList ?
                                brandsList.map(function (item) {
                                    return item.brand;
                                }) : [],
                            except: vm.brandFilter.brandSelection.excludedBrands ?
                                vm.brandFilter.brandSelection.excludedBrands.map(function (item) {
                                    return item.brand;
                                }) : []
                        }
                    } else {
                        vm.selectedFilters.brands = getSelectAllPaginatedModel();
                    }
                } else {
                    vm.selectedFilters.brands = $sessionStorage.hubImportBrandFilter ?
                        $sessionStorage.hubImportBrandFilter.brands || [] : [];
                }

                if (!vm.isImmoContext) {
                    if (vm.dynamicFilterOptions.categories.selectAllOption && angular.isFunction(vm.listCategoryFilterOptions)) {
                        vm.selectedFilters.categorySelection =
                            $sessionStorage.hubImportBrandFilter.categorySelection || getSelectAllPaginatedModel();
                    } else {
                        vm.selectedFilters.categories = $sessionStorage.hubImportBrandFilter.categories || [];
                    }

                    vm.selectedFilters.colors = $sessionStorage.hubImportBrandFilter.colors || [];
                    vm.selectedFilters.sizes = $sessionStorage.hubImportBrandFilter.sizes || [];
                }

                vm.filters = getMultiSelectFilters();
                vm.filters.brandSelection = mapBrandSelectionToFilter(vm.selectedFilters.brandSelection);
                vm.filters.bedrooms = vm.selectedFilters.bedrooms;
                delete vm.selectedFilters.brandSelection;
                delete vm.selectedFilters.bedrooms;
                delete $sessionStorage.hubImportBrandFilter;
                delete $sessionStorage.hubImportMultiSelectFilters;
                delete $sessionStorage.hubImportDynamicFilterOptions;
                onFilterChanged();

                var removeUpdateCountForSelectAllOnInit =
                    $scope.$watch('vm.dynamicFilterOptions.brands.model', function (newValue) {
                        if (newValue && newValue.length > 0) {
                            vm.selectedFiltersCount = getSelectedFiltersCount();
                            removeUpdateCountForSelectAllOnInit();
                        }
                    }, true);
            }
        }

        function mapBrandSelectionToFilter(brandSelection) {
            if (!brandSelection) {
                return {
                    allBrands: false,
                    brands: [],
                    excludedBrands: []
                }
            } else {
                return {
                    allBrands: brandSelection.allBrands,
                    brands: !brandSelection.brands ? [] : brandSelection.brands
                        .map(function (selectedBrand) {
                            return selectedBrand.brand;
                        }),
                    excludedBrands: !brandSelection.excludedBrands ? [] : brandSelection.excludedBrands
                        .map(function (excludedBrand) {
                            return excludedBrand.brand;
                        })
                }
            }
        }

        function mapBrandSelectionFromSelect(brandSelection) {
            if (!brandSelection) {
                return {
                    allBrands: false,
                    brands: [],
                    excludedBrands: []
                }
            } else {
                return {
                    allBrands: brandSelection.all || false,
                    brands: angular.copy(brandSelection.only || []),
                    excludedBrands: angular.copy(brandSelection.except || [])
                }
            }
        }

        function readFilterValues() {
            var filters = angular.copy(vm.filters);

            if (filters.configurations && (filters.configurations).includes("launch")) {
                filters.launch = true;
            } else {
                delete filters.launch;
            }

            if (filters.configurations && (filters.configurations).includes("basic")) {
                filters.basic = true;
            } else {
                delete filters.basic;
            }

            if (filters.configurations && (filters.configurations).includes("delivered")) {
                filters.delivered = true;
            } else {
                delete filters.delivered;
            }

            if (!filters.configurations || filters.configurations.length === 0) {
                delete filters.configurations;
            }

            if (!filters.launch || filters.launch.length === 0) {
                delete filters.launch;
            }

            if (!filters.basic || filters.basic.length === 0) {
                delete filters.basic;
            }

            if (!filters.delivered || filters.delivered.length === 0) {
                delete filters.delivered;
            }

            if (!filters.brandName || filters.brandName.length === 0) {
                delete filters.brandName;
            }

            if (!filters.brandFirstLetter || filters.brandFirstLetter.length === 0) {
                delete filters.brandFirstLetter;
            }

            if (!filters.activated || filters.activated.length === 0) {
                delete filters.activated;
            }

            if (!filters.type || filters.type.length === 0) {
                delete filters.type;
            }

            if (!filters.colors || filters.colors.length === 0) {
                delete filters.colors;
            }

            if (!filters.sizes || filters.sizes.length === 0) {
                delete filters.sizes;
            }

            if (!filters.bedrooms || filters.bedrooms.length === 0) {
                delete filters.bedrooms;
            }

            if (!filters.genders || filters.genders.length === 0) {
                delete filters.genders;
            }

            if (!filters.minValue || filters.minValue.length === 0) {
                delete filters.minValue;
            }

            if (!filters.maxValue || filters.maxValue.length === 0) {
                delete filters.maxValue;
            }

            if (!filters.region || filters.region.length === 0) {
                delete filters.region;
            }

            if (!filters.categories || filters.categories.length === 0) {
                delete filters.categories;
            }

            if (!filters.categoryKeys || filters.categoryKeys.length === 0) {
                delete filters.categoryKeys;
            }

            if (!filters.categoryKey || filters.categoryKey.length === 0) {
                delete filters.categoryKey;
            }

            if (!filters.categorySelection ||
                (!filters.categorySelection.all && filters.categorySelection.only.length === 0)) {
                delete filters.categorySelection;
            }

            if (!filters.brand || filters.brand.length === 0) {
                delete filters.brand;
            }

            if (!filters.brands || filters.brands.length === 0) {
                delete filters.brands;
            }

            if (!filters.brandSelection ||
                (!filters.brandSelection.allBrands && filters.brandSelection.brands.length === 0)) {
                delete filters.brandSelection;
            }

            return filters;
        }

        function readLoadFlyersFilterValues() {
            var loadFlyersFilter = readFilterValues();

            loadFlyersFilter.minValue = vm.selectedFilters.minValue;
            loadFlyersFilter.maxValue = vm.selectedFilters.maxValue;

            return loadFlyersFilter;
        }

        function loadAllBrands() {
            vm.isLoadingBrands = true;

            var loadAllBrandFilter = {
                allBrands: true,
                brands: [],
                excludedBrands: []
            };

            HubFlyersService.findAllBrands(loadAllBrandFilter, onSuccessLoadAllBrands, onErrorLoadAllBrands);
        }

        function onSuccessLoadAllBrands(data) {
            if (data && data.length > 0) {
                vm.brands = angular.copy(data);
            } else {
                vm.brands = [];
            }
            vm.isLoadingBrands = false;
        }


        function onErrorLoadAllBrands(err) {
            vm.isLoadingBrands = false;
            toastr.error($translate.instant('flyers.messages.load.error'));
        }

        function loadFlyers() {
            if (!vm.isLoadingFlyers && vm.filters) {

                var loadFlyerFilter = readLoadFlyersFilterValues();
                vm.isLoadingFlyers = true;
                HubFlyersService.listFlyers(vm.paginationOptions, loadFlyerFilter, onSuccessLoadFlyers, onErrorLoadFlyers);
            }
        }

        function onFilterChanged() {
            vm.selectedFiltersCount = getSelectedFiltersCount();
            vm.emptyFiltersShowcases =  isEmptyFilters();
            clearPaginationInfo();
            loadFlyers();
        }

        function isEmptyFilters(){
            return (vm.selectedFiltersCount > 0 || vm.filters.text !== undefined && vm.filters.text !== '') && vm.flyers.length <= 0;
        }

        function onSuccessLoadFlyers(data, headers) {
            if (data) {
                vm.flyers = angular.copy(data);
                mapSelectedFlyers(vm.flyers);

            }

            vm.totalFlyers = headers('X-Total-Count');
            updatePaginationDescription();
            vm.isLoadingFlyers = false;
            vm.emptyFiltersShowcases =  isEmptyFilters();
        }

        function mapSelectedFlyers(flyers) {
            if (flyers) {
                flyers.forEach(function (flyer) {
                    flyer.__isSelected = isFlyerSelected(flyer);
                });
            }
        }

        function onErrorLoadFlyers(error) {
            vm.isLoadingFlyers = false;
            toastr.error($translate.instant('flyers.messages.load.error'));
        }

        function isFlyerSelected(flyer) {
            var flyerBrandIndex = getFlyerSelectedBrandIndex(flyer);
            return (flyerBrandIndex !== -1
                    && !isFlyerExcluded(flyer)
                    && flyerMatchesBrandSelectionFilter(flyer, vm.selectedBrands[flyerBrandIndex].filter)
                )
                || getSelectedFlyerIndex(flyer) !== -1;
        }

        function flyerMatchesBrandSelectionFilter(flyer, selectionFilter) {
            var match = true;
            if (match && selectionFilter.text && selectionFilter.text !== '') {
                match = match && (
                    flyer.name.toLowerCase().includes(selectionFilter.text.toLowerCase())
                    || (flyer.productReference && flyer.productReference.toLowerCase().includes(selectionFilter.text.toLowerCase()))
                    || (flyer.tags && flyer.tags.some(function (tag) {
                        return tag.toLowerCase().includes(selectionFilter.text.toLowerCase());
                    }))
                );
            }

            if (match && selectionFilter.categoryKeys && selectionFilter.categoryKeys.length > 0) {
                match = match && selectionFilter.categoryKeys
                    && selectionFilter.categoryKeys.includes(flyer.categoryKey);
            }

            if (match && selectionFilter.color) {
                match = match && selectionFilter.color === flyer.color;
            }

            if (match && selectionFilter.type) {
                match = match && selectionFilter.type === flyer.type;
            }

            if (match && selectionFilter.bedrooms) {
                match = match && flyer.details && flyer.details.some(function (detail) {
                    return detail.bedroom && selectionFilter.bedrooms.includes(detail.bedroom);
                });
            }

            if (match && selectionFilter.configurations && selectionFilter.configurations.length > 0) {
                var flyerConfigurationAttributeNames = selectionFilter.configurations.map(function (configuration) {
                    return 'is' + _.capitalize(configuration);
                });
                flyerConfigurationAttributeNames.forEach(function (attributeName) {
                    match = match && flyer[attributeName] === true;
                });
            }

            if (match && selectionFilter.region && selectionFilter.region.length > 0) {
                selectionFilter.region.forEach(function (polygon) {
                    match = match && flyer.address && (
                        flyer.address.longitude <= polygon.longitudeHi &&
                        flyer.address.longitude >= polygon.longitudeLo &&
                        flyer.address.latitude <= polygon.latitudeHi &&
                        flyer.address.latitude >= polygon.latitudeLo
                    )
                });
            }

            var flyerFinalValue = undefined;

            if (match && selectionFilter.minValue) {
                if (flyer.details && flyer.details.length > 0) {
                    match = match && flyer.details.some(function (detail) {
                        var detailFinalValue = detail.discountedValue ? detail.discountedValue : detail.purchaseValue;
                        return detailFinalValue >= selectionFilter.minValue;
                    })
                } else {
                    flyerFinalValue = flyer.discountedValue ? flyer.discountedValue : flyer.purchaseValue;
                    match = match && flyerFinalValue >= selectionFilter.minValue;
                }
            }

            if (match && selectionFilter.maxValue) {
                if (flyer.details && flyer.details.length > 0) {
                    match = match && flyer.details.some(function (detail) {
                        var detailFinalValue = detail.discountedValue ? detail.discountedValue : detail.purchaseValue;
                        return detailFinalValue <= selectionFilter.maxValue;
                    })
                } else {
                    flyerFinalValue = flyer.discountedValue ? flyer.discountedValue : flyer.purchaseValue;
                    match = match && flyerFinalValue >= selectionFilter.maxValue;
                }
            }

            return match;
        }

        function isFlyerExcluded(flyer) {
            var flyerBrandIndex = vm.selectedBrands.findIndex(function (selectedBrand) {
                return selectedBrand.brand === flyer.brand;
            });
            return flyerBrandIndex !== -1 && vm.selectedBrands[flyerBrandIndex].excludedFlyers
                .some(function (excludedFlyer) {
                    return excludedFlyer.id === flyer.id;
                });
        }

        function refreshSelectedFlyers(toggledFlyer) {
            var flyerBrandIndex = getFlyerSelectedBrandIndex(toggledFlyer);
            if (flyerBrandIndex !== -1) {
                var excludedFlyerIndex = vm.selectedBrands[flyerBrandIndex]
                    .excludedFlyers.findIndex(function (excludedFlyer) {
                        return excludedFlyer.id === toggledFlyer.id;
                    });
                if (excludedFlyerIndex !== -1) {
                    vm.selectedBrands[flyerBrandIndex]
                        .excludedFlyers.splice(excludedFlyerIndex, 1);
                } else {
                    vm.selectedBrands[flyerBrandIndex]
                        .excludedFlyers.push({ brand: vm.selectedBrands[flyerBrandIndex].brand, id: toggledFlyer.id });
                }
            } else {
                var flyerIndex = getSelectedFlyerIndex(toggledFlyer);
                if (flyerIndex !== -1) {
                    vm.selectedFlyers.splice(flyerIndex, 1);
                } else {
                    vm.selectedFlyers.push({ brand: toggledFlyer.brand, id: toggledFlyer.id });
                }
            }
            mapSelectedFlyers(vm.flyers);
        }

        function getSelectedFlyerIndex(flyer) {
            return vm.selectedFlyers.findIndex(function (selectedFlyer) {
                return selectedFlyer.id === flyer.id;
            });
        }

        function getFlyerSelectedBrandIndex(flyer) {
            return vm.selectedBrands.findIndex(function (selectedBrand) {
                return selectedBrand.brand === flyer.brand;
            });
        }

        function getExcludedFlyerIndex(flyer) {
            var flyerBrandIndex = getFlyerSelectedBrandIndex(flyer);
            if (flyerBrandIndex !== -1) {
                return vm.selectedBrand[flyerBrandIndex].excludedFlyers.findIndex(function (excludedFlyer) {
                    return excludedFlyer.id === flyer.id;
                });
            } else {
                return flyerBrandIndex;
            }
        }

        function onChangeItemsPerPage(newValue) {
            vm.itemsPerPage = newValue;

            clearPaginationInfo();
            changePage();
        }

        function changePage() {
            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.itemsPerPage;

            loadFlyers();
        }

        function updatePaginationDescription() {
            var begin = ((vm.currentPage - 1) * vm.itemsPerPage),
                end = begin + vm.itemsPerPage;
            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalFlyers);
        }

        function onSelectedSortOption(newValue) {
            vm.selectedSortByOption = newValue;
            vm.filters.sortBy = vm.selectedSortByOption.value;
            vm.filters.sortDirection = vm.selectedSortByOption.direction;
            clearPaginationInfo();
            loadFlyers();
        }

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.itemsPerPage
            };
        }

        function getContextTranslateKey(baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        }

        function initializeMassSelectionActionsOptions() {
            vm.selectionTypes = [
                {
                    value: 'ALL',
                    translation: 'flyers.selection-filters.select-all',
                    selectFn: selectAllFiltered
                },
                {
                    value: 'ALL_FROM_PAGE',
                    translation: 'flyers.selection-filters.select-all-from-page',
                    selectFn: selectAllFromPage
                },
                {
                    value: 'NONE',
                    translation: 'flyers.selection-filters.select-none',
                    selectFn: unselectAll
                }
            ];
        }

        function selectAllFiltered() {
            if (vm.selectedFilters.brands) {
                var includeAllBrands =
                    (vm.selectedFilters.brands.all && vm.selectedFilters.brands.except.length === 0) ||
                    (!vm.selectedFilters.brands.all && vm.selectedFilters.brands.only.length === 0);
                vm.selectedFlyers = [];
                var includedBrands;
                if (includeAllBrands) {
                    includedBrands = vm.brands;
                } else {
                    if (vm.selectedFilters.brands.all) {
                        includedBrands = vm.brands.filter(function (brand) {
                            return !vm.selectedFilters.brands.except.some(function (excludedBrand) {
                                return excludedBrand === brand.brand;
                            });
                        });
                    } else {
                        includedBrands = vm.brands.filter(function (brand) {
                            return vm.selectedFilters.brands.only.some(function (selectedBrand) {
                                return selectedBrand === brand.brand;
                            });
                        })
                    }
                }
                var configuredFilters = angular.copy(vm.filters);
                vm.selectedBrands = includedBrands.map(function (item) {
                    var brandSpecificFilter = angular.copy(configuredFilters);
                    brandSpecificFilter.brandSelection = {
                        allBrands: false,
                        brands: [item.brand],
                        excludedBrands: []
                    };
                    return { brand: item.brand, filter: brandSpecificFilter, excludedFlyers: [] };
                })
                mapSelectedFlyers(vm.flyers);
            }
            vm.loadingSelection = false;
        }

        function selectAllFromPage() {
            if (isAllFromPageSelected()) {
                unselectAllFromPage();
            } else {
                var flyerSelections = vm.flyers.filter(function (flyer) {
                    return !isFlyerSelected(flyer);
                }).map(function (flyer) {
                    return { brand: flyer.brand, id: flyer.id };
                });
                flyerSelections.forEach(function (flyerSelection) {
                    var flyerBrandIndex = getFlyerSelectedBrandIndex(flyerSelection);
                    if (flyerBrandIndex !== -1) {
                        var excludedIndex = getExcludedFlyerIndex(flyerSelection);
                        if (excludedIndex !== -1) {
                            vm.selectedBrands[flyerBrandIndex].excludedFlyers.splice(excludedIndex, 1);
                        }
                    }
                    vm.selectedFlyers.push(flyerSelection);
                });
            }
            mapSelectedFlyers(vm.flyers);
            vm.loadingSelection = false;
        }

        function unselectAll() {
            vm.selectedFlyers = [];
            vm.selectedBrands = [];
            vm.selectionExcludedFlyers = [];
            mapSelectedFlyers(vm.flyers);
            vm.loadingSelection = false;
        }

        function isAllFromPageSelected() {
            return vm.flyers.length > 0 && vm.flyers.every(function (flyer) {
                return isFlyerSelected(flyer);
            });
        }

        function noneSelected() {
            return (!vm.selectedFlyers || vm.selectedFlyers.length === 0)
                && (!vm.selectedBrands || vm.selectedBrands.length === 0);
        }

        function isIndeterminate() {
            var filteredSelected = vm.flyers.filter(function (flyer) {
                var selectedIndex = vm.selectedFlyers.findIndex(function (selectedFlyer) {
                    return selectedFlyer.id === flyer.id
                });
                return selectedIndex !== -1;
            });
            return (vm.selectedFlyers.length > 0 && filteredSelected.length !== vm.flyers.length)
                || (vm.selectedBrands.length < 0 && vm.selectedBrands.length !== vm.brands.length);
        }

        function unselectAllFromPage() {
            if (vm.flyers && vm.flyers.length > 0) {
                vm.flyers.forEach(function (flyer) {
                    if (isFlyerSelected(flyer)) {
                        var flyerIndex = getSelectedFlyerIndex(flyer);
                        if (flyerIndex !== -1) {
                            vm.selectedFlyers.splice(flyerIndex, 1);
                        } else {
                            var selectedBrandIndex = vm.selectedBrands.findIndex(function (selectedBrand) {
                                return selectedBrand.brand === flyer.brand;
                            });
                            if (selectedBrandIndex !== -1) {
                                vm.selectedBrands[selectedBrandIndex]
                                    .excludedFlyers.push({ name: flyer.brand, id: flyer.id });
                            }
                        }
                    }
                })
            }
            vm.loadingSelection = false;
        }

        function getMultiSelectFilters() {
            return $sessionStorage.hubImportMultiSelectFilters || {
                region: [],
                categories: [],
                brands: [],
                colors: [],
                sizes: [],
                genders: [],
                bedrooms: [],
                configurations: [],
                minValue: null,
                maxValue: null
            };
        }

        function loadFilter(filterType, listKey, singleKey, valueKey, paginatedSelectionKey) {
            var filterOptions = vm.selectedFilters[filterType];

            if (angular.isArray(filterOptions)) {
                if (filterOptions.length > 0) {
                    var formatedList = filterOptions.map(function (item) {
                        return item[valueKey];
                    });

                    vm.filters[listKey] = formatedList;

                    if (singleKey && formatedList.length > 0) {
                        vm.filters[singleKey] = formatedList[0];
                    }
                } else {
                    delete vm.filters[listKey];
                    if (singleKey) {
                        delete vm.filters[singleKey];
                    }
                }
            } else {
                if (paginatedSelectionKey) {
                    var formatedPaginatedSelection;
                    if (paginatedSelectionKey === 'brandSelection') {
                        formatedPaginatedSelection = mapBrandSelectionFromSelect(filterOptions);
                    } else {
                        formatedPaginatedSelection = angular.copy(filterOptions);
                        formatedPaginatedSelection.except = formatedPaginatedSelection.except.map(function (item) {
                            return item[valueKey];
                        });
                        formatedPaginatedSelection.only = formatedPaginatedSelection.only.map(function (item) {
                            return item[valueKey];
                        });
                    }

                    vm.filters[paginatedSelectionKey] = formatedPaginatedSelection;
                } else {
                    delete vm.filters[paginatedSelectionKey];
                }
            }
            onFilterChanged();
        }

        function loadFiltersOptions() {
            vm.configurations = getConfigurationsValues();

            initializeMassSelectionActionsOptions();
        }

        function getConfigurationsValues() {
            var configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }

            return configurations;
        }

        function openFiltersModal() {
            $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                dynamicFilterOptions: vm.dynamicFilterOptions,
                                brandValueMap: vm.brandValueMap,
                                bedrooms: vm.bedrooms,
                                configurations: vm.configurations,
                                clearFilters: vm.clearFilters,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.itemsPerPage,
                                selectedSort: vm.selectedSortByOption,
                                listCategoryFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listCategoryFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listBrandFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listBrandFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listColorFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listColorFilterOptions(pageable, search, onSuccess, onError);
                                },
                                listSizeFilterOptions: function (pageable, search, onSuccess, onError) {
                                    return HubFlyersService.listSizeFilterOptions(pageable, search, onSuccess, onError);
                                }
                            },
                            filters: vm.selectedFilters,
                            list: vm.filters,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.filters = response.listFilter;
                    if (vm.filters.brandSelection) {
                        vm.filters.brandSelection = mapBrandSelectionFromSelect(vm.filters.brandSelection);
                    }
                    vm.selectedFilters = response.selectedFilters;

                    if (response.numPerPage && response.numPerPage !== vm.itemsPerPage) {
                        vm.itemsPerPage = response.numPerPage;
                    }

                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.filters.sortBy = vm.selectedSortByOption.value;
                        vm.filters.sortDirection = vm.selectedSortByOption.direction;
                    }

                    onFilterChanged();
                }
            });
        }

        function getSelectedFiltersCount() {
            return calculateDynamicFilterSelectedCount(vm.selectedFilters.categories, vm.dynamicFilterOptions.categories)
                + calculateDynamicFilterSelectedCount(vm.selectedFilters.brands, vm.dynamicFilterOptions.brands)
                + (Array.isArray(vm.filters.bathrooms) ? vm.filters.bathrooms.length : 0)
                + (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0)
                + (Array.isArray(vm.filters.parkingSpots) ? vm.filters.parkingSpots.length : 0)
                + (Array.isArray(vm.filters.region) ? vm.filters.region.length : 0)
                + calculateDynamicFilterSelectedCount(vm.selectedFilters.colors, vm.dynamicFilterOptions.colors)
                + calculateDynamicFilterSelectedCount(vm.selectedFilters.sizes, vm.dynamicFilterOptions.sizes)
                + (Array.isArray(vm.filters.genders) ? vm.filters.genders.length : 0)
                + (Array.isArray(vm.filters.configurations) ? vm.filters.configurations.length : 0)
                + (Array.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0)
                + (vm.filters.minValue && vm.filters.maxValue ? 1 : 0)
                + (vm.filters.sinceDate && !isNaN(vm.filters.sinceDate.getTime())
                && vm.filters.untilDate && !isNaN(vm.filters.untilDate.getTime()) ? 1 : 0);
        }

        function calculateDynamicFilterSelectedCount(dynamicFilterModel, dynamicFilterOptions) {
            var selectedCount = 0;
            if (angular.isArray(dynamicFilterModel)) {
                selectedCount = dynamicFilterModel.length;
            } else if (angular.isObject(dynamicFilterModel)) {
                if (dynamicFilterOptions.selectAllOption) {
                    if (dynamicFilterModel.all) {
                        selectedCount = dynamicFilterOptions.totalItems - dynamicFilterModel.except.length;
                    } else {
                        selectedCount = dynamicFilterModel.only.length;
                    }
                } else {
                    selectedCount = dynamicFilterModel.only ? dynamicFilterModel.only.length : 0;
                }
            }
            return selectedCount;
        }

        function finishImport() {
            var importHubFilter = {
                flyers: vm.selectedFlyers,
                brands: vm.selectedBrands
            }
            vm.isSaving = true;
            FlyersService.importFromHub(importHubFilter).then(function () {
                toastr.success($translate.instant(getContextTranslateKey('flyers.import-hub.import-hub-started')));
                vm.isSaving = false;
                $state.go('flyers');
            }).catch(function(err) {
                var errorMessage = $translate.instant('flyers.import-hub.import-hub-error');
                console.warn(errorMessage, err);
                toastr.error(errorMessage);
                vm.isSaving = false;
            });
        }

        function goBack() {
            $state.go('flyers.import-hub');
        }
    }
})();
